// @flow

import { GraphQLError } from 'graphql/error';
import type { FetchFunction } from 'react-relay';

const makeFetch: FetchFunction = (operation, variables) => (
  fetch(
    window._graphql.url,
    {
      method: 'POST',
      headers: {
        ...window._graphql.headers,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        query: operation.text,
        variables
      })
    }
  ).then((response) => (
    response.json().then((json) => {
      if (json && json.errors && json.errors.length) {
        throw new GraphQLError("The query failed", null, json);
      }
      return json;
    })
  ))
);

export default makeFetch;
